import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js'

import EventEmitter from './EventEmitter.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'

export default class Resources extends EventEmitter
{
    constructor(sources)
    {
        super()

        this.sources = sources
        console.log(sources)
        this.loadingManager = new THREE.LoadingManager(
            // Loaded callback
            () => {
                gsap.to(overlayMaterial.uniforms.uAlpha, { duration: 1, value: 0 })
              // Hide the loading screen
            // document.getElementById('spinner').style.display = 'none';
            // document.getElementById('fullscreen-overlay').style.display = 'none';
        
        
            }
            ,
        
            (url, itemsLoaded, itemsTotal) => {
              // Update the progress bar
              const progressRatio = itemsLoaded / itemsTotal
            }
          );
          this.loadingManager.onStart = function(url, itemsLoaded, itemsTotal) {
            // document.getElementById('spinner').style.display = 'block';
            // document.getElementById('fullscreen-overlay').style.display = 'block';
          };
        
          // Hide spinner once everything has finished loading
          this.loadingManager.onLoad = function() {
            // document.getElementById('spinner').style.display = 'none';
            // document.getElementById('fullscreen-overlay').style.display = 'none';
          };
        this.items = {}
        this.toLoad = this.sources.length
        this.loaded = 0
var data
        // this.setLoaders()
        // this.loading()
        // this.startLoading()
      
    }

  setLoaders()
    {
        this.loaders = {}
        this.loaders.gltfLoader = new GLTFLoader(this.loadingManager)
        this.loaders.glbLoader = new GLTFLoader(this.loadingManager)
        this.loaders.objLoader=new OBJLoader(this.loadingManager)
        this.loaders.textureLoader = new THREE.TextureLoader(this.loadingManager)
        this.loaders.cubeTextureLoader = new THREE.CubeTextureLoader(this.loadingManager)
        this.loaders.dracoLoader=new DRACOLoader()
        this.loaders.dracoLoader.setDecoderPath('/draco/')
        this.loaders.glbLoader.setDRACOLoader(this.loaders.dracoLoader)

    }

  startLoading(pathFile)
    {
        // Load each source
        for(const source of this.sources)
        {
            if(source.type === 'gltfModel')
            {
                this.loaders.gltfLoader.load(
                    source.path,
                    (file) =>
                    {
                        this.sourceLoaded(source, file)
                    }
                )
            }
            else if(source.type === 'glbModel')
            {
                this.loaders.glbLoader.load(
                    pathFile,
                    (file) =>
                    {
                        this.sourceLoaded(source, file)
                    }
                )
            }
            else if(source.type === 'OBJModel')
            {
                this.loaders.objloader.load(
                    source.path,
                    (file) =>
                    {
                        this.sourceLoaded(source, file)
                    }
                )
            }
            else if(source.type === 'texture')
            {
                this.loaders.textureLoader.load(
                    source.path,
                    (file) =>
                    {
                        this.sourceLoaded(source, file)
                    }
                )
            }
            else if(source.type === 'cubeTexture')
            {
                this.loaders.cubeTextureLoader.load(
                    source.path,
                    (file) =>
                    {
                        this.sourceLoaded(source, file)
                    }
                )
            }
            else if(source.type === 'json'){
var data
                source.path = data
                this.loaders.gltfLoader.parse(
                    JSON.stringify(source.path),"",
                    (file) =>
                    {
                        this.sourceLoaded(source, file)
                    }
                )
            }
        }
    }

    sourceLoaded(source, file)
    {
        this.items[source.name] = file

        this.loaded++

        if(this.loaded === this.toLoad)
        {
            this.trigger('ready')
        }
    }
    loading(){
       
        
    }
}